import { allPools } from '../model';
import type { Pool } from '../model';

export const getPoolByApiKey = (apiKey: string): Pool | undefined =>
  allPools.find(({ apiKeyPrefix }) => apiKey.startsWith(apiKeyPrefix));
